<app-toaster></app-toaster>
<div class="main-container" [ngClass]="{ mobile: isMobileLayout }">
  <app-header class="app-header"></app-header>
  <div *ngIf="isMobileLayout" class="overflow-auto h-100 custom-scroll mt-3">
    <main role="main" class="app-main mobile">
      <router-outlet></router-outlet>
    </main>
    <app-footer class="app-footer"></app-footer>
  </div>
  <main *ngIf="!isMobileLayout" role="main" class="app-main">
    <router-outlet></router-outlet>
  </main>
  <app-footer *ngIf="!isMobileLayout" class="app-footer"></app-footer>
</div>
